import { Container, Row, Col, Image } from 'react-bootstrap'

const SuccessStoryAaron = () => (
    <>
    <div className="section-success-stories-aaron">
        <Container>
            <Row>
                <Col md={5} className="text-center">
                    <Image src="../images/7bs/img-testimonial-02.png" alt="Success story Aaron" className="img-fluid d-block mx-auto mb-3"/>
                    <p><small><em>Results May Vary From Person To Person <a href="#results-may-vary">*</a></em></small></p>
                </Col>
                <Col md={7}>
                    <div className="testimonial">
                        <h3>Success stories</h3>
                        <p><em>"I used to feel like an outsider. Now, I'm finally able to go out for sports, and I'm president of my high school intramural club!"</em></p>
                        <p><em>"My After-After is my ability to actually enjoy life. I'm no longer in the shadows; I'm living my life!" <a href="#results-may-vary">*</a></em></p>
                        <p>- Aaron</p>
                    </div>
                </Col>
            </Row>
        </Container>
    </div>
    <style jsx global>{`

            .section-success-stories-aaron {
                background: #EEE9E3;
                font-size: 20px;
            }

            .section-success-stories-aaron .container {
                padding-top: 60px;
                padding-bottom: 60px;
            }

            .section-success-stories-aaron .testimonial {
                background: #fff;
                padding: 30px 30px 10px;
            }

            .section-success-stories-aaron h3 {
                font-weight: 700;
                margin-bottom: 30px;
            }

            .section-success-stories-aaron a {
                color: #de7621;
            }

            .section-success-stories-aaron p {
                margin-bottom: 30px;
            }

            @media (max-width: 767.98px) {

            }

        `}</style>
    </>
);

export default SuccessStoryAaron;